import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { appMeta } from '../../interfaces/appMeta';

@Component({
  selector: 'app-side-menu-new',
  templateUrl: './side-menu-new.component.html',
  styleUrls: ['./side-menu-new.component.css'],
})
export class SideMenuNewComponent implements OnInit {
  environment = environment;
  @Input() subscription_id: string = '';

  appMeta: appMeta;

  ngOnInit(): void {
    this.appMeta = {
      componentType: this.environment.assetTitle,
      subscriptionId: this.subscription_id,
      stage: 'input',
    };
  }

  constructor(private router: Router) {}
}
